import React, { FC, ReactNode } from 'react';

import { TeamDisplay } from '@nhl/nhl-react-ui/lib/TeamDisplay';

import { GameCenterTeam } from '../../types';

import { HeaderContainer, HeaderText, HeaderTextContainer, SubHeaderText, TeamContainer } from './styles';

type Props = {
    awayTeam: GameCenterTeam;
    homeTeam: GameCenterTeam;
    headerMessage: ReactNode;
    subMessage?: ReactNode;
};

const HeaderSection: FC<Props> = ({ awayTeam, homeTeam, headerMessage, subMessage }) => (
    <HeaderContainer>
        <TeamContainer>
            <TeamDisplay logoUrlOverride={awayTeam.logo} team={{ triCode: awayTeam.abbrev }} displayName={false} />
        </TeamContainer>
        <HeaderTextContainer role="heading" aria-level={2}>
            <HeaderText>{headerMessage}</HeaderText>
            {subMessage && <SubHeaderText>{subMessage}</SubHeaderText>}
        </HeaderTextContainer>
        <TeamContainer>
            <TeamDisplay logoUrlOverride={homeTeam.logo} team={{ triCode: homeTeam.abbrev }} displayName={false} />
        </TeamContainer>
    </HeaderContainer>
);

export default HeaderSection;
